import { ReactComponent as OpenIcon } from './icons/open.svg'
import { ReactComponent as OpenIssueIcon } from './icons/openIssue.svg'
import { ReactComponent as DraftIcon } from './icons/draft.svg'
import { ReactComponent as MergedIcon } from './icons/merged.svg'
import { ReactComponent as ClosedIcon } from './icons/closed.svg'
import { ReactComponent as ClosedIssueIcon } from './icons/closedIssue.svg'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export class FetchError extends Error {
  constructor(public res: Response, message?: string) {
    super(message)
  }
}

export const githubPullIcon = (status: 'merged' | 'open' | 'open-issue' | 'closed' | 'closed-issue' | 'draft') => {
  switch (status) {
    case 'open':
      return <OpenIcon title="open" width={24} />
    case 'open-issue':
      return <OpenIssueIcon title="open" width={24} />
    case 'draft':
      return <DraftIcon title="draft" width={24} />
    case 'merged':
      return <MergedIcon title="merged" width={24} />
    case 'closed':
      return <ClosedIcon title="closed" width={24} />
    case 'closed-issue':
      return <ClosedIssueIcon title="closed" width={24} />
  }
}

export const parseDate = (dateString?: string) => {
  let date: Date
  try {
    date = new Date(dateString ?? '')
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date')
    }
  } catch (e) {
    try {
      date = dayjs(dateString ?? '', 'YYYY-MM-DD HH:mm:ss [UTC]').toDate()
    } catch (e) {
      date = new Date()
    }
  }
  return date
}
